import { createRequestQueue, RequestQueue } from 'owa-service-utils';
import { createSDSCollection } from './createSDSCollection';
import { createSDSCollectionItem } from './createSDSCollectionItem';
import { ErrorCodes } from '../utils/errorCodes';
import { updateSDSCollectionItem } from './updateSDSCollectionItem';

const MAXIMUM_NUM_REQUESTS = 1;
let requestQueue: RequestQueue = null;

/**
 * Return an instance of RequestQueue
 * Allows for MAXIMUM_NUM_REQUESTS in parallel and queues the rest for execution
 */
const getRequestQueue = () => {
    if (!requestQueue) {
        requestQueue = createRequestQueue(MAXIMUM_NUM_REQUESTS);
    }
    return requestQueue;
};

/**
 * Service to upsert an item in a collection in SDS
 * @param collectionName Collection in which the item is to be updated
 * @param itemClass Item Class to be put if a new item is to be created inside a collection
 * @param body Key value pairs to be updated
 * unexpected errors which are reported: Please do not store EMPTY ARRAYS in SDS, it will throw an error saying CollectionTypeNameRequired
 */
export async function upsertSDSCollectionItem(
    collectionName: string,
    itemClass: string,
    body: any
) {
    const { add: addToQueue } = getRequestQueue();
    return addToQueue(async () => {
        const response = await updateSDSCollectionItem(collectionName, body);
        if (response?.Id) {
            return response;
        }
        if (response?.error) {
            if (response.error.code === ErrorCodes.CollectionIdNotFound) {
                await createSDSCollection(collectionName);
            }
            return createSDSCollectionItem(collectionName, itemClass, body);
        } else {
            return null;
        }
    });
}
